import {
  createColumnHelper,
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { Modal, Tooltip } from "flowbite-react";
import { flatMap, has } from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import ReactPaginate from "react-paginate";
import { NavLink } from "react-router-dom";
import api from "../../apis/axiosInterceptor";
import allImgPaths from "../../assets";
import { IconButton } from "../../components";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import Table from "../../components/table";
import { useAppState } from "../../context";
import { useDebounce } from "../../hooks/useDebounce";

type Questionaries = {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  createdAt: string;
};
const PAGE_LIMIT = 10;
let flagOfIndex = 0;
const Employee = () => {
  const { getEmployees, employeesData, isLoading, totalPageCount, totalData } =
    useAppState("employees");
  const PAGE_LIMIT_OPTIONS = [10, 25, 50, 100];
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_LIMIT);
  const [open, setOpen] = useState(false);
  const [curUserData, setCurUserData] = useState<any>();
  const [dpImage, setDpImage] = useState<string>();
  const [fromSearch, setFromSearch] = useState(false);
  // Function to handle rows per page change
  const cPage = currentPage;
  const startIndex = (cPage - 1) * rowsPerPage + 1;
  const endIndex = startIndex - 1 + employeesData.length;
  const totalRecords = totalData;

  useEffect(() => {
    if (
      curUserData?.image !== undefined &&
      curUserData?.image !== "undefined"
    ) {
      setDpImage(`${process.env.REACT_APP_API_URL}/${curUserData?.image}`);
    } else {
      setDpImage(allImgPaths.defaultProfile);
    }
  }, [curUserData]);
  /* Table Section Start */
  const columnHelper = createColumnHelper<Questionaries>();
  const defaultColumns = [
    columnHelper.accessor(
      (row, index: number) => (flagOfIndex - 1) * rowsPerPage + index + 1,
      {
        id: "no",
        header: () => <span className="">No.</span>,
        cell: (info) => (
          <span className="text-[#1B1C1E]">{info.getValue()}</span>
        ),
      },
    ),
    columnHelper.accessor((row) => row.firstName, {
      id: "firstName",
      header: () => <span className="">First Name</span>,
      cell: (info) => <span className="text-[#1B1C1E]">{info.getValue()}</span>,
    }),
    columnHelper.accessor((row) => row.lastName, {
      id: "lastName",
      header: () => <span className="">Last Name</span>,
      cell: (info) => <span className="text-[#1B1C1E]">{info.getValue()}</span>,
    }),
    columnHelper.accessor((row) => row.email, {
      id: "email",
      header: () => <span className="">Email Id</span>,
      cell: (info) => <span className="text-[#1B1C1E]">{info.getValue()}</span>,
    }),
    columnHelper.accessor((row) => row.createdAt, {
      id: "createdAt",
      header: () => <span className="">Date</span>,
      cell: (info) => (
        <span className="capitalize text-[#1B1C1E]">
          {moment(info.getValue()).format("DD/MM/YYYY")}
        </span>
      ),
    }),
    columnHelper.accessor((row) => row, {
      id: "Action",
      header: () => <span className="">Action</span>,
      cell: (info) => {
        return (
          <Tooltip content="Preview" placement="bottom">
            <IconButton
              icon={allImgPaths.eyeOpenWhite}
              className={`bg-[#808b9a]`}
              onClick={() => {
                handleUserById(info.getValue().id);
              }}
            />
          </Tooltip>
        );
      },
    }),
  ];

  const getEmployeesDetailById = async (userId: string) => {
    try {
      const result: any = await api.get(
        `/api/v1/users/findOne?userId=${userId}`,
      );

      if (result.data.status) {
        setCurUserData(result.data.data);

        return true;
      } else {
        const errorStr = has(result.data, "errors")
          ? Object(flatMap(result.data))[1].msg
          : result.data.message;
        toast.error(errorStr);
        // setState({ ...state, error: errorStr });
        setCurUserData({ error: errorStr });
        return false;
      }
    } catch (error: any) {
      toast.error(error.message);
      // setState({ ...state, error: error.message });
      setCurUserData({ error: error.message });
      return false;
    }
  };
  const [columns, setColumns] = useState<typeof defaultColumns>(() => [
    ...defaultColumns,
  ]);
  const table = useReactTable({
    data: employeesData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    initialState: {
      pagination: {
        pageSize: rowsPerPage,
      },
    },
  });
  /* Table Section End */
  const debouncedSearch: string | number = useDebounce(search, 700);
  const handleRowsPerPageChange = (event: any) => {
    setRowsPerPage(parseInt(event.target.value));
    setCurrentPage(1); // Reset to the first page when changing rows per page
    table.setPageSize(parseInt(event.target.value));
  };
  /* New code start */
  useEffect(() => {
    flagOfIndex = currentPage;
  }, [currentPage]);
  useEffect(() => {
    setColumns([...defaultColumns]);
  }, [rowsPerPage]);
  /* New code End */

  useEffect(() => {
    getEmployees(currentPage, rowsPerPage, debouncedSearch);
  }, [currentPage, rowsPerPage, debouncedSearch]);
  const handleUserById = async (userId: any) => {
    const res = await getEmployeesDetailById(userId);

    if (res) {
      setOpen(true);
    }
  };
  useEffect(() => {
    if (!fromSearch) {
      setCurrentPage(currentPage);
    } else {
      setCurrentPage(1);
    }
  });
  return (
    <Layout>
      <Breadcrumb title="Employee Listing" />
      <Container>
        <div className="">
          <div className="flex ">
            <div className="flex gap-5 w-full justify-between">
              <div className="flex relative h-full justify-start">
                <input
                  className="rounded-[5px] !h-9 bg-[#F4F4F4] outline-none focus:!shadow-none border-[1px] outline-0 text-sm"
                  type="text"
                  value={search}
                  placeholder="Search Employee"
                  onChange={(event) => {
                    setFromSearch(true);
                    setSearch(event.target.value.trim());
                  }}
                />
                <div className="absolute right-1 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-4 w-4 items-center justify-center flex">
                  {search ? (
                    <img
                      className="cursor-pointer"
                      src={allImgPaths.cross}
                      alt="search"
                      onClick={() => {
                        setFromSearch(true);
                        setSearch("");
                      }}
                    />
                  ) : (
                    <img
                      className="cursor-pointer"
                      src={allImgPaths.search}
                      alt="search"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2">
            <Table
              table={table}
              emptyRecordMsg="No record found"
              isLoading={isLoading}
              loadingMsg="Fetching..."
            />
          </div>
          {/* Pagination Start */}
          <div className="mt-2 pb-4">
            <div className="flex justify-between items-center mt-6">
              {totalData == 0 ? (
                ""
              ) : (
                <div>
                  <span className="mr-2 text-sm">Rows per page:</span>
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="border rounded px-2 py-1 text-sm w-[75px]"
                  >
                    {PAGE_LIMIT_OPTIONS.map((option) => (
                      <option key={option} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              {totalData == 0 ? (
                ""
              ) : (
                <div>
                  <h3 className="text-sm">
                    Showing entries {startIndex} to {endIndex} out of{" "}
                    {totalRecords}
                  </h3>
                </div>
              )}
              {totalPageCount > 0 && (
                <ReactPaginate
                  activeClassName="flex items-center group active rounded justify-center h-7 text-white bg-[#2E5528] hover:bg-[#2E5528]"
                  pageLinkClassName="px-3 text-black group-[&.active]:text-white hover:bg-[#2E5528] hover:text-white"
                  pageClassName="cursor-pointer hover:text-white flex items-center rounded justify-center h-7 text-blue-600 text-black hover:bg-[#2E5528] hover:text-white"
                  className="flex gap-5 items-center text-sm"
                  breakLabel="..."
                  nextLabel={currentPage === totalPageCount ? "" : ">"}
                  onPageChange={(event) => {
                    setFromSearch(false);
                    setCurrentPage(+event.selected + 1);
                  }}
                  forcePage={currentPage - 1}
                  pageRangeDisplayed={1}
                  pageCount={totalPageCount}
                  previousLabel={currentPage === 1 ? "" : "<"}
                  renderOnZeroPageCount={null}
                />
              )}
            </div>
          </div>
          {/* Pagination End */}
        </div>
      </Container>

      <Modal
        show={open}
        onClose={() => setOpen(false)}
        dismissible
        size="5xl"
        className="w-full p-0"
      >
        <Modal.Header>
          <div>Employee Detail</div>
        </Modal.Header>
        <Modal.Body className="w-full pad-0">
          <div className="grid grid-cols-2 my-2 p-2">
            <div className="flex justify-stat items-center">
              <div className="relative w-20 h-20 cols-span-2">
                <div className="relative w-full h-full rounded-full overflow-hidden border-2 border-gray-300">
                  <img
                    id="profilePic"
                    src={dpImage}
                    alt="Profile"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="ml-2 border-l-2 border-indigo-200 border-l-indigo-500">
                <div className="grid grid-cols-1 mx-4">
                  <label className="gap-1">
                    <span className="font-bold">First Name : </span>
                    {curUserData && curUserData?.firstName}
                  </label>
                  <label className="gap-1 ">
                    <span className="font-bold">Last Name : </span>

                    {curUserData && curUserData?.lastName}
                  </label>
                  <label className="gap-1">
                    <span className="font-bold">Email : </span>

                    {curUserData && curUserData?.email}
                  </label>
                  <label className="flex items-center gap-1">
                    <span className="font-bold">Gender : </span>

                    {curUserData && curUserData?.gender}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="grid grid-cols-2 gap-4 my-2 p-4">
            <label>
              <span className="font-bold my-2 px-2 py-1 text-sm rounded text-white bg-green-500">
                Educations :
              </span>

              {curUserData?.educations?.length > 0 ? (
                curUserData?.educations?.map((curEle: any, index: number) => (
                  <div key={curEle._id}>
                    <p className="flex gap-1 my-2">
                      <b>Name :</b> {curEle.name}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Degree :</b>

                      {curEle.degree}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Study :</b> {curEle.study}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Grade :</b> {curEle.grade}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Start Date :</b>{" "}
                      {moment(curEle.startDate).format("DD/MM/YYYY")}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>End Date :</b>{" "}
                      {moment(curEle.endDate).format("DD/MM/YYYY")}
                    </p>
                    {index !== curUserData.educations.length - 1 && (
                      <hr className="my-2 border-gray-300 w-5/6" />
                    )}
                  </div>
                ))
              ) : (
                <p>No Degree Detail available.</p>
              )}
            </label>
            <label>
              <span className="font-bold my-2 px-2 py-1 text-sm rounded text-white bg-amber-500">
                Experience :
              </span>

              {curUserData?.experience?.length > 0 ? (
                curUserData?.experience?.map((curEle: any, index: number) => (
                  <div key={curEle._id}>
                    <p className="flex gap-1 my-2">
                      <b>Company Name : </b>

                      {curEle.companyName}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Title :</b>

                      {curEle.title}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Employment Type :</b> {curEle.employmentType}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Location :</b> {curEle.location}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Location Type :</b>

                      {curEle.locationType}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Start Date :</b>

                      {moment(curEle.startDate).format("DD/MM/YYYY")}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>End Date :</b>

                      {moment(curEle.endDate).format("DD/MM/YYYY")}
                    </p>
                    {index !== curUserData.experience.length - 1 && (
                      <hr className="my-2 border-gray-300 w-5/6" />
                    )}
                  </div>
                ))
              ) : (
                <p>No Experience Detail available.</p>
              )}
            </label>
            <label>
              <span className="font-bold px-2 py-1 text-sm rounded text-white bg-red-500">
                Certificate :
              </span>

              {curUserData?.certificate?.length > 0 ? (
                curUserData?.certificate?.map((curEle: any) => (
                  <div key={curEle._id}>
                    <p className="flex gap-1 my-2">
                      <b>Name :</b> {curEle.name}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Provider :</b> {curEle.provider}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Completion Id :</b> {curEle.completionId}
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Url : </b>
                      <NavLink
                        to={`https://${curEle.url}`}
                        target="_blank"
                        className=""
                      >
                        {curEle.url}
                      </NavLink>
                    </p>
                    <p className="flex gap-1 my-2">
                      <b>Validity : </b>

                      {moment(curEle.validity).format("DD/MM/YYYY")}
                    </p>
                  </div>
                ))
              ) : (
                <p>No Certificate Detail available.</p>
              )}
            </label>
            <label>
              <span className="font-bold px-2 py-1 text-sm rounded text-white bg-slate-500">
                Save Question :
              </span>
              <br />
              {curUserData?.saveQuestion &&
              curUserData.saveQuestion.length > 0 ? (
                <div className="flex items-start justify-center">
                  <h5 className="font-bold mt-1 w-[25%] ">QuestionSlug :</h5>
                  <div className="flex flex-wrap gap-1 w-[75%]">
                    {curUserData?.saveQuestion?.map((curEle: any) => (
                      <span
                        key={curEle._id}
                        className="py-1 px-3 max-w-max flex items-center rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 hover:bg-opacity-75 focus:bg-gray-300 focus:text-blue-900 active:text-primary active:bg-blue-100"
                      >
                        <p>{curEle.questionSlug}</p>
                      </span>
                    ))}
                  </div>
                </div>
              ) : (
                <p>No Save Question Detail available.</p>
              )}
            </label>
          </div>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Employee;
